import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../shared/Context/Context.js";
import NavbarDesktop from "./NavbarDesktop/NavbarDesktop.jsx";
import NavbarMobile from "./NavbarMobile/NavbarMobile.jsx";

const Navbar = () => {
  const [visible, setVisible] = useState(false);
  const {
    setJwt,
    isRegistered,
    setIsRegistered,
    setIsAdmin,
    tabletOrLess
  } = useContext(Context);
  let navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsRegistered(false);
    setIsAdmin(false);
    setVisible(false);
    setJwt(null);
    navigate("/");
  };

  return <>
    {tabletOrLess ? <NavbarMobile isRegistered={isRegistered} logout={logout} setVisible={setVisible} visible={visible}/> : <NavbarDesktop isRegistered={isRegistered} logout={logout} setVisible={setVisible} visible={visible}/>}
  </>;
};

export default Navbar;
